<template>
  <HeaderDialog
    :show="show"
    :color="primaryColor"
    :title="title"
    :subtitle="subtitle"
    :loading="loading"
    @close="$emit('close')"
    @action="$emit('ok')"
    :close-text="$t('action.cancel')"
    :width="width"
    :actionText="btnActionText || $t('action.confirm')"
  >
    <template v-slot:body>
      <Alert v-if="alert && alert.show" dense :color="alert.type">
        {{ alert.message }}
      </Alert>
      <v-card-text class="ma-0 mt-3 pa-0 text-body-1" v-html="messageToShow" />
      <v-card-text
        class="ma-0 px-0 pb-0 pt-4 text-body-1"
        v-if="!hideReversibleText && !unsavedChanges"
      >
        {{
          reversible
            ? $t("common.reversibleAction")
            : $t("common.irreversibleAction")
        }}
      </v-card-text>
      <v-card-text :class="customBodyClass">
        <slot></slot>
      </v-card-text>
    </template>
  </HeaderDialog>
</template>
<script>
import { warnings } from "@/helpers/variables/warnings";
import { mapGetters } from "vuex";
export default {
  name: "ConfirmationDialog",
  props: {
    customBodyClass: { type: String, default: "" },
    width: { type: String, required: false },
    show: { type: Boolean, required: true },
    loading: { type: Boolean, required: false },
    actionText: { type: String, required: true },
    target: { type: String, default: "" },
    unsavedChanges: { type: Boolean, default: false },
    reversible: { type: Boolean, default: true },
    hideReversibleText: { type: Boolean, default: false },
    message: { type: String, default: "" },
    alert: { type: [Object, Boolean], default: false },
    btnActionText: { type: String, default: "" },
  },
  data() {
    return {
      warnings,
    };
  },
  computed: {
    ...mapGetters(["primaryColor"]),
    title() {
      return this.target ? this.target : this.actionText;
    },
    subtitle() {
      return this.target ? this.actionText : "";
    },
    messageToShow() {
      if (this.message) {
        return `${this.message}`;
      } else {
        if (this.unsavedChanges) {
          return this.$t("common.exitWithoutSaving");
        } else {
          return this.actionText
            ? this.$t("common.sureToContinueAction", {
                action: this.actionText.toLowerCase(),
              })
            : this.$t("common.sureToContinue");
        }
      }
    },
  },
};
</script>
